import React from 'react'

import Link from '../../Link'
import { FooterCountrySelector } from '../FooterCountrySelector'
import { FooterLegalFootnotes } from '../FooterLegalFootnotes'
import { FooterLegalMenu } from '../FooterLegalMenu'
import { FooterLinks } from '../FooterLinks'
import { SocialMediaMenu } from '../SocialMediaMenu'

import logo from '../../../../img/logo-designs-for-health-textonly.svg'

export { FooterPrint } from './Print'

export const Footer: React.FC = () => (
  <footer className="bg-brand-navy w-full text-brand-white p-5 xl:p-10 min-h-[485px] font-gotham flex justify-center print:hidden">
    <div className="max-w-[1920px] w-full">
      <section className="md:flex md:justify-between items-center mb-[30px] xl:">
        <Link to="/" className="w-auto h-auto">
          <img
            src={logo}
            alt="Designs for Health"
            className="h-[18.48px] my-[8.16px] md:h-[27.17px] md:my-3"
          />
        </Link>

        <SocialMediaMenu />
      </section>
      <section className="xl:grid xl:grid-cols-[2fr_1fr] pb-10 border-b">
        <FooterLinks />
        <FooterCountrySelector />
      </section>
      <section className="xl:flex xl:w-full xl:gap-x-14 mb-10 mt-10">
        <h2 className="text-sm font-semibold mb-2.5">Terms & Conditions</h2>
        <FooterLegalMenu />
      </section>
      <FooterLegalFootnotes />
    </div>
  </footer>
)
